import { render, staticRenderFns } from "./RelationIntentList.vue?vue&type=template&id=1ff9bb01&scoped=true"
import script from "./RelationIntentList.vue?vue&type=script&lang=js"
export * from "./RelationIntentList.vue?vue&type=script&lang=js"
import style0 from "./RelationIntentList.vue?vue&type=style&index=0&id=1ff9bb01&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff9bb01",
  null
  
)

export default component.exports